import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { GET_PARAMETROS_INTEGRACAO_INIT, UPDATE_PARAMETROS_INTEGRACAO_INIT, VALIDAR_DADOS_PGLOADER_INIT } from '../../actionTypes';
import {
  errorParametrosIntegracaoMsg,
  getParametrosIntegracaoSuccess,
  updateParametrosIntegracaoSuccess,
  validarDadosPgloaderSuccess
} from './actions';
import { atualizarParametrosIntegracao, obtemParametrosIntegracao, validarDadosPgloader } from 'src/integracoes/servicos/mongo-atlas/funcoes/parametrosIntegracao';
import { IParametrosIntegracao } from 'src/integracoes/servicos/mongo-atlas/modelos/IParametrosIntegracao';
import { FarmaError } from 'src/integracoes/modelos/erros';

// -------------------Obter Paramêtros Integracao-----------------------------
const fetchObtemParametrosIntegracao = async (id: string) => {
  try {
    const { status, dados, mensagem } = await obtemParametrosIntegracao(id);

    if (status) {
      return {
        isError: false,
        parametrosIntegracao: dados,
        errorMessage: ''
      };
    }
    return {
      isError: true,
      parametrosIntegracao: null,
      errorMessage: mensagem
    };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

export function* paraseObtemParametrosIntegracao({ payload }: { payload: any, type: any }) {
  const { id } = payload;
  try {
    const { isError, parametrosIntegracao, errorMessage } = yield call(fetchObtemParametrosIntegracao, id);
    if (!isError) {
      yield put(getParametrosIntegracaoSuccess({ parametrosIntegracao }));
    } else {
      yield put(errorParametrosIntegracaoMsg({ msg: errorMessage }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(errorParametrosIntegracaoMsg({ msg: mensagem }));
  }
}

export function* watchObtemParametrosIntegracao() {
  yield takeEvery(GET_PARAMETROS_INTEGRACAO_INIT, paraseObtemParametrosIntegracao);
}

// --------------------------- Atualiza Parametros Integracao ---------------------------------------------------------
const fetchAtualizarParametrosIntegracao = async (id: string, parametrizacaoIntegracao: IParametrosIntegracao) => {
  try {
    const { status, dados, mensagem } = await atualizarParametrosIntegracao(id, parametrizacaoIntegracao);
    if (status) {
      return {
        isUpdated: true,
        msg: mensagem,
        data: dados
      };
    } else {
      return { isUpdated: false, msg: mensagem, data: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseAtualizaParametrosIntegracao({ payload }: { payload: any, type: any }) {
  const { id, parametrosIntegracao } = payload;
  try {
    const { isUpdated, msg } = yield call(fetchAtualizarParametrosIntegracao, id, parametrosIntegracao);
    if (isUpdated) {
      yield put(updateParametrosIntegracaoSuccess({ msg }));
    } else {
      yield put(errorParametrosIntegracaoMsg({ msg }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(errorParametrosIntegracaoMsg({ msg: mensagem }));
  }
}

export function* watchAtualizaParametrosIntegracao() {
  yield takeEvery(UPDATE_PARAMETROS_INTEGRACAO_INIT, parseAtualizaParametrosIntegracao);
}

// --------------------------- Validar Dados Pgloader ---------------------------------------------------------
const fetchValidarDadosPgloader = async (id: string) => {
  try {
    const { status, dados, mensagem } = await validarDadosPgloader(id);
    if (status) {
      return {
        isValidated: true,
        msg: mensagem,
        data: dados
      };
    } else {
      return { isValidated: false, msg: mensagem, data: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseValidarDadosPgloader({ payload }: { payload: any, type: any }) {
  const { id } = payload;
  try {
    const { isValidated, msg, data } = yield call(fetchValidarDadosPgloader, id);
    if (isValidated) {
      yield put(validarDadosPgloaderSuccess({ msg, dados: data }));
    } else {
      yield put(errorParametrosIntegracaoMsg({ msg }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(errorParametrosIntegracaoMsg({ msg: mensagem }));
  }
}

export function* watchValidarDadosPgloader() {
  yield takeEvery(VALIDAR_DADOS_PGLOADER_INIT, parseValidarDadosPgloader);
}

// WATCHS ------------------------------------------------
export default function* rootSaga() {
  yield all([
    fork(watchObtemParametrosIntegracao),
    fork(watchAtualizaParametrosIntegracao),
    fork(watchValidarDadosPgloader)
  ]);
}
